<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'QACategoryCenter',
            to: {
              name: 'QACategoryCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'QACategoryCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增類別 -->
    <QACategoryCreateEdit></QACategoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACategoryCreateEdit from '@/views/G-3__QACategory/c/QACategoryCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    QACategoryCreateEdit,
  },
  computed: {
    ...mapState('qacategory', ['qacategory']),
  },
  created() {
    this.setQACategory({});
  },
  methods: {
    ...mapActions('qacategory', ['setQACategory', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'QACategoryCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.qacategory.title) {
          this.errors.push('標題 required.');
        } else if (!this.qacategory.bu_id) {
          this.errors.push('BU required.');
        } else if (!this.qacategory.support_categories_id) {
          this.errors.push('類別 required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.qacategory).then(() => {
          this.$router.push({ name: 'QACategoryCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
